import {Injectable} from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {TerceroUPPasarelaProducto} from '../_models/tercero-up-pasarela-producto';
import {InfoCanalPasarelaDTO, InfoServicioPasarelaDTO} from '../_models/info-canales-pasarelas.dto';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TerceroUpPasarelaProductoService {
  private rutServicio = AppSettings.rutServiciosTER + '/api/tercerosUPPasarelasProductos';
  private rutProductosPasarelas = AppSettings.rutServiciosAPL + '/api/productosPasarelas';

  constructor(private httClient: HttpClient) {
  }

  obtenerInfoCanalesPasarelas(idTerceroUPPasarela: string): Observable<InfoCanalPasarelaDTO[]> {
    return this.httClient
      .get(`${this.rutProductosPasarelas}/obtenerInfoCanalesPasarelas/terceroUPPasarela/${idTerceroUPPasarela}`)
      .pipe(map(res => res as InfoCanalPasarelaDTO[]));
  }


  obtenerInfoServicioPasarelas(idTerceroUPPasarela: string): Observable<InfoServicioPasarelaDTO> {
    return this.httClient
      .get(`${this.rutProductosPasarelas}/obtenerInfoServicioPasarelas/terceroUPPasarela/${idTerceroUPPasarela}`)
      .pipe(map(res => res as InfoServicioPasarelaDTO));
  }

  listMetodosPasarela(idTerceroUPPasarela: string) {
    return this.httClient.get(`${this.rutServicio}/listMetodosPasarela/${idTerceroUPPasarela}`).pipe(map(res => res as TerceroUPPasarelaProducto[]));
  }

  obtenerTercerosPasarelaProductos(idTerceroUPPasarela: string, idProductoPasarela: string): Observable<TerceroUPPasarelaProducto> {
    return this.httClient
      .get(`${this.rutServicio}/obtenerTercerosPasarelaProductos/terceroUPPasarela/${idTerceroUPPasarela}/productoPasarela/${idProductoPasarela}`)
      .pipe(map(res => res as TerceroUPPasarelaProducto));
  }

  crearPasarelaVersion(registro: TerceroUPPasarelaProducto) {
    return this.httClient.post(`${this.rutServicio}/createPasareleVersion`, registro).pipe(map(res => res as TerceroUPPasarelaProducto));
  }
}
